module.exports = __webpack_public_path__ + "img/6.786aeec9.jpg";